
import ConnectLinkedIn from '@/components/content-share/ConnectLinkedIn';
import CurrentUserEditMutation from '@/graphql/mutations/CurrentUserEdit.gql';
import qs from 'querystring';

export default {
  components: {
    ConnectLinkedIn
  },
  methods: {
    async connectLinkedInForPosting() {
      const response = typeof this.$route.hash === 'string' ? qs.parse(this.$route.hash.substr(1)) : null;
      this.$log.debug(response);

      const {
        access_token: accessToken,
        expires_at: expiresAt,
        expires_in: expiresIn,
        id: linkedInUserID,
        name: linkedInName,
        email: linkedInEmail,
        scope,
      } = response;

      this.$assert(accessToken, 'Missing accessToken from LinkedIn sign-in');
      this.$assert(linkedInUserID, 'Missing id from LinkedIn sign-in');

      const { id: userID } = this.user;
      const update = {
        state: {
          linkedIn: {
            accessToken,
            expiresAt,
            expiresIn,
            scope,
            id: linkedInUserID,
            name: linkedInName,
            email: linkedInEmail,
            version: 'v1'
          },
        },
      };

      this.$log.debug({ update });

      await this.$apollo.mutate({
        mutation: CurrentUserEditMutation,
        variables: { userID, update },
      });

      // Clear callback query & auth details from URL
      this.$router.replace({
        ...this.$route,
        query: { callback: this.$route.query ? this.$route.query.callback : null },
        hash: ''
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/connectLinkedIn.js